module.exports = __webpack_public_path__ + "img/ill_badge_tariff_not_available.53e1ed55.svg";